import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AnalyticsService} from './analytics.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [],
  exports: []
})
export class AnalyticsModule {
}
